import { useState } from 'react';

const useMultiLanguageInput = ({ input, isMultiLanguage }) => {
  const [language, setLanguage] = useState('en');

  const handleSelectLanguage = (lng) => setLanguage(lng);

  if (!input) {
    return null;
  }

  const multiLanguageInput = { ...input };

  if (isMultiLanguage) {
    multiLanguageInput.value = input.value?.[language];
    multiLanguageInput.onChange = (val) =>
      input.onChange({ ...input.value, [language]: val });
  }

  return { input: multiLanguageInput, language, handleSelectLanguage };
};

export default useMultiLanguageInput;
